import { render, staticRenderFns } from "./BookingMenu.vue?vue&type=template&id=c0a4f680&"
import script from "./BookingMenu.vue?vue&type=script&lang=js&"
export * from "./BookingMenu.vue?vue&type=script&lang=js&"
import style0 from "./BookingMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports